<!--
  Using display none here allows the header to render immediately and start downloading
  the logo image while isLoading is true.
-->
<div [ngClass]="{'d-none': isLoading}">
  <app-header></app-header>
</div>

<div *ngIf="isLoading ; else loaded" class="container-fluid position-fixed d-flex justify-content-center align-items-center h-100">
  <loader [isLoading]="isLoading"></loader>
</div>

<ng-template #loaded>

  <main class="content-area-wrapper mb-4"
        [class.imperva]="mode === CustomMode.Imperva">
    <router-outlet></router-outlet>
  </main>

</ng-template>
